import { Dayjs } from "dayjs";

export function formatOneDecimal(value: number): string {
  return String(Number(value.toFixed(1)));
}

export function formatHours(hours: number): string {
  return `${formatOneDecimal(hours)} h`;
}

export function formatShare(share: number | null): string {
  return share === null ? "—" : `${Math.round(share * 100)}%`;
}

export function formatDateRange(from: Dayjs, to: Dayjs): string {
  const sameYear = from.year() === to.year();
  return `${from.format(sameYear ? "D MMM" : "D MMM YYYY")} – ${to.format("D MMM YYYY")}`;
}
